const BAIDU_AK = 'LnM4tI8JHSto8moVF0cgf0dKKJmGbF0x';
export function loadBaiduMap() {
  return new Promise((resolve, reject) => {
    if (window.BMapGL) return resolve(window.BMapGL);
    const script = document.createElement('script');
    script.src = `https://api.map.baidu.com/api?v=1.0&type=webgl&ak=${BAIDU_AK}&callback=initMap`;
    script.onerror = () => reject(new Error('百度地图脚本加载失败'));
    window.initMap = () => {
      delete window.initMap;
      resolve(window.BMapGL);
    };
    document.head.appendChild(script);
  });
}